export { default } from './ProviderSocialLinks';
